import React, { useState } from "react";
import styles from "./index.module.css";
import ForgotBanner from "../../elements/ForgotBanner";
import ForgotYourPassword from "../../elements/ForgotYourPassword";
import ConfirmOTP from "../../elements/ConfirmOTP";
import EnterNewPassword from "../../elements/EnterNewPassword";

const Forgot = () => {
  const [username, setUsername] = useState("");
  const [otp, setOtp] = useState("");
  const [visibility, setVisibility] = useState({
    forgotYourPassword: true,
    confirmOTP: false,
    enterNewPassword: false,
  });

  return (
    <ForgotBanner>
      {visibility.forgotYourPassword ? (
        <ForgotYourPassword
          userEmail={username}
          setUsername={setUsername}
          setVisibility={setVisibility}
        />
      ) : visibility.confirmOTP ? (
        <ConfirmOTP setVisibility={setVisibility} username={username} />
      ) : (
        <EnterNewPassword />
      )}
    </ForgotBanner>
  );
};

export default Forgot;
